import kamala from '../../kamala'
import Form from './Form'
import FormItem from './FormItem'

const KFormFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(Form.name, Form)
    Vue.component(FormItem.name, FormItem)
  },
  KForm: Form,
  KFormItem: FormItem,
}

export { Form, FormItem }

export default KFormFamily
